import React from "react";
import _ from "lodash";
import styled from "styled-components";
import arrowIcon from "../assets/images/icons/svg/arrow-small-orange.svg";

const CarPageAvatarWrapper = styled.div`
  font-family: "Roboto Mono";
  overflow: hidden;
  margin: 0 auto;
  padding: 0;
  background-position: 20px 0px;
  background-repeat: no-repeat;
  background-color: white;
  z-index: 3;
  margin-left: 30px;

  @media (max-width: 767.98px) {
    width: 100%;
    max-width: 400px;
    margin: 30px auto;
    border: 30px solid #fff;
    border-bottom: none;
  }

  > div {
    display: flex;
    flex-flow: column;
    flex-wrap: wrap;
    height: 580px;
    justify-content: space-between;
    width: 100%;

    &.calc-data.modal-height {
      height: 680px;

      @media (max-width: 767.98px) {
        padding: 0;
      }
    }

    &:hover,
    &:focus,
    &:active {
      border: none;
      text-decoration: none;
    }

    > a {
      border-bottom: 1px solid transparent;
      box-sizing: content-box;
      color: #ff5000;
      cursor: pointer;
      display: block;
      height: 26px;
      line-height: 30px;
      margin-bottom: 55px;
      padding-bottom: 0px;
      text-transform: uppercase;
      width: 260px;

      &:hover,
      &:active,
      &:focus {
        text-decoration: none;
        border-bottom: 1px solid #ff5000;
        outline: none;
      }
    }

    @media (max-width: 767.98px) {
      width: 100%;
    }
  }
  .car-avatar-desc {
    background: transparent;
    z-index: 3;
    display: flex;
    flex-wrap: wrap;
    &--main {
      display: flex;
      flex-wrap: wrap;
      margin-top: auto;

      .car-manufacture {
        color: #ff5000;
      }
      > span {
        width: 100%;
      }
    }
    &--parameters {
      opacity: 0;
      background: transparent;
      top: auto;
      bottom: 90px;
      left: 20px;
      transition: opacity 0.3s linear;
    }
    > span {
      color: rgb(143, 144, 146);
      margin-top: 0;
      text-transform: uppercase;

      &.large {
        position: relative;
        color: rgb(0, 0, 1);
        font-family: "marscondensed-regular";
        font-size: 28px;
        line-height: 1;
        text-transform: uppercase;
        margin-left: 0px;
        transition: margin-left 0.2s ease-out;
        img,
        svg {
          position: absolute;
          left: -40px;
          top: 9px;
          display: inline-block;
          width: 14px;
          height: 20px;
          margin-left: 12px;
          opacity: 0;
        }
      }
    }
  }
  .car-avatar--from-price {
    text-transform: uppercase;
    background: #ff5000;
    color: white;
    font-size: 16px;
    padding: 5px 15px;
    z-index: 3;
    font-size: 14px;
    width: 100%;
  }
  .car-avatar-calc {
    margin-top: 25px;
    margin-bottom: 35px;
    > div {
      padding: 15px 9px;
      background: #eceef2;
      margin: 0 5px 5px 0;
      padding-right: 24px;
      &:last-child {
        padding-right: 54px;
      }

      @media (max-width: 767.98px) {
        padding-right: 10px;
        &:last-child {
          padding-right: 25px;
        }
      }

      span {
        display: inline-block;
        text-transform: uppercase;

        &.key,
        &.suffix {
          display: block;
          font-size: 12px;
          line-height: 12px;
          font-weight: 300;
          color: #7f7f7f;
          margin-bottom: 5px;
        }

        &.value {
          font-size: 18px;
          line-height: 18px;
          font-weight: 500;
          color: #000;
        }

        &.suffix {
          display: inline-block;
          text-transform: none;
        }
      }
    }
  }
  .car-avatar-tags {
    margin-top: 25px;
    margin-bottom: 35px;
    > span {
      background: #eceef2;
      font-size: 12px;
      line-height: 18px;
      color: #7f7f7f;
      padding: 0 6px;
      margin-right: 6px;
      margin-top: 6px;
    }
  }
`;

const CarPageAvatar = props => {
  const {
    acceleration,
    bodyType,
    drive,
    engineCapacity,
    enginePower,
    engineType,
    gearType,
    year
  } = props.carData.acf.parameters;

  const availableNowFile = _.get(
    props.carData,
    "acf.availableNow.availableNowFile"
  );

  const showAvailableButton = _.get(
    props.carData,
    "acf.availableNow.availableNowCheckbox",
    false
  );

  const showCalcData = !!props.calculatorData;

  const calcData =
    _.get(props, "calculatorData.calcType", "") === "najem"
      ? {
          wartosc: props.calculatorData.CalculatorRentLong.d,
          wplata: props.calculatorData.CalculatorRentLong.e,
          okres: props.calculatorData.CalculatorRentLong.f
        }
      : _.get(props, "calculatorData.calcType", "") === "leasing"
        ? {
            wartosc: props.calculatorData.CalculatorLeasing.d,
            wplata: props.calculatorData.CalculatorLeasing.e,
            okres: props.calculatorData.CalculatorLeasing.f
          }
        : {};

  return (
    <CarPageAvatarWrapper
      style={{ backgroundImage: `url(${props.carData.acf.vehicleAvatar})` }}
    >
      <div className={`calc-data ${props.modal ? "modal-height" : ""}`}>
        {showAvailableButton && (
          <p className="car-avatar--from-price">Dostępny od ręki!</p>
        )}
        <div className="car-avatar-desc car-avatar-desc--main">
          <span className="car-manufacture">
            {props.carData.title.rendered.split(" ")[0]}
          </span>
          <span className="large">
            {props.carData.title.rendered
              .split(" ")
              .slice(1)
              .join(" ")}
            <img className="svg" src={arrowIcon} alt="Question icon arrow" />
          </span>
        </div>
        {showCalcData && (
          <div className="car-avatar-desc car-avatar-calc">
            <div>
              <span className="key">Umowa</span>
              <span className="value">{props.calculatorData.calcType}</span>
            </div>
            <div>
              <span className="key">Wartość katalogowa</span>
              <span className="value">{calcData.wartosc} ZŁ</span>
            </div>
            <div>
              <span className="key">Wpłata własna</span>
              <span className="value">{calcData.wplata}%</span>
            </div>
            <div>
              <span className="key">Okres umowy</span>
              <span className="value">{calcData.okres}</span>
              <span className="suffix">/mies.</span>
            </div>
          </div>
        )}
        {!showCalcData && (
          <div className="car-avatar-desc car-avatar-tags">
            <span className="car-year">{year}</span>
            <span className="car-engineCapacity">{engineCapacity}</span>
            <span className="car-power">
              {enginePower}
              km
            </span>
            <span className="car-power">{acceleration}s</span>
            <span className="car-engineType">{engineType.name}</span>
            <span className="car-gear">{gearType.name}</span>
            <span className="car-drive">{drive.name}</span>
            <span className="car-type">{bodyType.name}</span>
          </div>
        )}
        {availableNowFile && (
          <a href={availableNowFile} target="_blank" rel="noopener noreferrer">
            Zobacz specyfikację pojazdu
          </a>
        )}
      </div>
    </CarPageAvatarWrapper>
  );
};

export default CarPageAvatar;
